import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { FlowInputStep } from '../types/FlowInputStep';

export type GetFlowInputStepsParams = {
  readonly flowId: string;
};

export type GetFlowInputStepsResult = IResult & {
  readonly inputSteps: ReadonlyArray<FlowInputStep>;
  // flows?
  // connections?
};

export class GetFlowInputStepsRequest extends Request<GetFlowInputStepsParams, GetFlowInputStepsResult> {
  constructor(params: GetFlowInputStepsParams) {
    super('getFlowInputSteps', params);
  }
}
